import { useQuery, useMutation, useQueryClient } from 'react-query';
import { apiClient } from '../services/apiClient';
import {
  MetersDataReadDTO,
  MetersDataCreateDTO,
  BatchMetersDataRequest,
} from '../generated/api-client';
import { toYyyyMmDd } from '../utils/date.utils';

export const useMetersData = () => {
  return useQuery<MetersDataReadDTO[]>('metersData', () => apiClient.list_items_meters_data__get());
};

export const useMetersDataById = (id: string) => {
  return useQuery<MetersDataReadDTO>(
    ['metersData', id],
    () => apiClient.get_item_meters_data__item_id__get(id),
    {
      enabled: !!id,
    }
  );
};

export const useCreateMetersData = () => {
  const queryClient = useQueryClient();

  return useMutation<MetersDataReadDTO, Error, MetersDataCreateDTO>(
    data => apiClient.create_item_meters_data__post(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('metersData');
      },
    }
  );
};

export const useUpdateMetersData = () => {
  const queryClient = useQueryClient();

  return useMutation<MetersDataReadDTO, Error, { id: string; data: MetersDataCreateDTO }>(
    ({ id, data }) => apiClient.update_item_meters_data__item_id__put(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('metersData');
      },
    }
  );
};

export const useDeleteMetersData = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, string>(
    id => apiClient.delete_item_meters_data__item_id__delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('metersData');
      },
    }
  );
};

export const useBatchSaveMetersData = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, Array<MetersDataCreateDTO & { id?: string }>>(
    items => {
      // Converti i DTO in dict plain per il backend
      const itemsAsDict = items.map(item => {
        const dict: any = { value: null };
        if (item.id) dict.id = item.id;
        if (item.meter_id !== undefined) dict.meter_id = item.meter_id;
        if (item.month !== undefined) dict.month = toYyyyMmDd(item.month);
        if (item.value !== undefined) dict.value = item.value;
        return dict;
      });
      const request = { items: itemsAsDict } as BatchMetersDataRequest;
      return apiClient.batch_save_meters_data_batch_post(request);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('metersData');
      },
    }
  );
};
